import React from 'react'
import { Link } from 'gatsby';


const HomePageCTA = () => {
  return ( 
    <div className="bg-white pt-16 pb-32">
      <div className="px-6 sm:px-6">
        <div className="mx-auto max-w-5xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-tight">You don’t have time to wait for a new status page.</h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-gray-600">It’s only a matter of time before your next incident. </p>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-gray-600"><strong>You need a tool that works for you and <i>you need it now.</i></strong>  But you don’t need to replace your entire workflow with a bloated buffet of features you’ll never use. You just need this one part of it to work and <i>to work really, really well.</i></p>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-gray-600"><strong>We won’t ignore your questions, or wait days to reply.</strong> <br />We’ll get you everything you need to make your decision as quickly.</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link to="/demo" className="rounded-md bg-gray-900 px-5 py-4 text-base font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">Get a Custom Demo</Link>
            <a href="https://app.sorryapp.com/people/sign_up?plan=price_0QSH3a596061iK2wzf4dPxQ4&subscribers=1000&pages=1&privacy=false" className="text-base font-semibold leading-6 text-gray-600 underline underline-offset-2 hover:text-gray-900">Start Your 7-Day Free Trial <span aria-hidden="true">→</span></a>
          </div>
        </div>
      </div>
    </div>

   );
}
 
export default HomePageCTA;